export const INITIAL_STATE = {
  getLoyaltyDetails: null,
  getLoyaltyDetailsLoading: false,
  getLoyaltyDetailsSuccess: null,
  getLoyaltyDetailsFailure: null,

  getLoyaltyActivity: null,
  getLoyaltyActivityLoading: false,
  getLoyaltyActivitySuccess: null,
  getLoyaltyActivityFailure: null,

  getLoyaltyConstant: null,
  getLoyaltyConstantLoading: false,
  getLoyaltyConstantSuccess: null,
  getLoyaltyConstantFailure: null,

  redeemRewards: null,
  redeemRewardsLoading: false,
  redeemRewardsSuccess: null,
  redeemRewardsFailure: null,

  redeemRewardsStatusCheck: null,
  redeemRewardsStatusCheckLoading: false,
  redeemRewardsStatusCheckSuccess: null,
  redeemRewardsStatusCheckFailure: null,

  getLoyaltyPromotions: null,
  getLoyaltyPromotionsLoading: false,
  getLoyaltyPromotionsSuccess: null,
  getLoyaltyPromotionsFailure: null,

  activateLoyaltyPromotions: null,
  activateLoyaltyPromotionsLoading: false,
  activateLoyaltyPromotionsSuccess: null,
  activateLoyaltyPromotionsFailure: null,

  getLoyaltyGameData: null,
  getLoyaltyGameDataLoading: false,
  getLoyaltyGameDataSuccess: null,
  getLoyaltyGameDataFailure: null,

  updateLoyaltyGameData: null,
  updateLoyaltyGameDataLoading: false,
  updateLoyaltyGameDataSuccess: null,
  updateLoyaltyGameDataFailure: null
};
